import React from 'react';
import { TColor, TextLarge, TextRegular, TextSmall } from '@hz-design-system/web-ui';

import Classes from './ListingDescription.module.scss';

interface ListingDescriptionProps {
  description?: string;
  color?: TColor;
}

interface ListingDescriptionComponent {
  Large: React.FC<ListingDescriptionProps>;
  Regular: React.FC<ListingDescriptionProps>;
  Small: React.FC<ListingDescriptionProps>;
}

const ListingDescriptionLarge: React.FC<ListingDescriptionProps> = ({ description, color }) => (
  <TextLarge className={Classes['hz-Listing-description-new']} color={color}>
    {description}
  </TextLarge>
);

const ListingDescriptionRegular: React.FC<ListingDescriptionProps> = ({ description, color }) => (
  <TextRegular className={Classes['hz-Listing-description-new']} color={color}>
    {description}
  </TextRegular>
);

const ListingDescriptionSmall: React.FC<ListingDescriptionProps> = ({ description, color }) => (
  <TextSmall className={Classes['hz-Listing-description-new']} color={color}>
    {description}
  </TextSmall>
);

const ListingDescription: ListingDescriptionComponent = {
  Large: ListingDescriptionLarge,
  Regular: ListingDescriptionRegular,
  Small: ListingDescriptionSmall,
};

export default ListingDescription;
